export enum WalletTypeEnum {
  BALANCE = 1,
  DEMO = 2, // ?
  BF_TICKETS = 500,
  BF_XP = 501,
}
